/**
 * Consent Service - Cookie consent state (localStorage-based)
 * Gates GTM loading; when consent is granted, GTM is initialized.
 */

import { analyticsService } from './analyticsService';

const CONSENT_STORAGE_KEY = 'arbiwin_cookie_consent';

/**
 * Get current consent value: true (accepted), false (declined), or null (not yet responded).
 * @returns {boolean|null}
 */
function getConsent() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (raw === null) return null;
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * Store consent and optionally initialize GTM when accepted.
 * @param {boolean} accepted - Whether the user accepted analytics/marketing cookies
 */
function setConsent(accepted) {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, String(accepted));
    if (accepted) {
      const gtmId = process.env.REACT_APP_GTM_ID;
      if (gtmId) {
        analyticsService.initialize(gtmId);
      }
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Consent] Could not persist consent:', e);
    }
  }
}

/**
 * Whether the user has already responded to the consent banner.
 * @returns {boolean}
 */
function hasResponded() {
  const consent = getConsent();
  return consent === true || consent === false;
}

export const consentService = {
  getConsent,
  setConsent,
  hasResponded
};
